import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("hsm_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("hsm_cart", JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const add = (product, size = "", color = "") => {
      setItems((prev) => {
        const key = `${product.id}:${size}:${color}`;
        const found = prev.find((i) => `${i.id}:${i.size}:${i.color || ""}` === key);
        if (found) return prev.map((i) => (`${i.id}:${i.size}:${i.color || ""}` === key ? { ...i, qty: Math.min(i.qty + 1, 20) } : i));
        return [...prev, { id: product.id, name: product.name, price: product.price, image: product.images?.[0] || "", size, color, qty: 1 }];
      });
      toast.success(`${product.name} added to bag`);
    };
    const remove = (id, size, color) => setItems((prev) => prev.filter((i) => !(i.id === id && i.size === size && (i.color || "") === (color || ""))));
    const setQty = (id, size, qty, color) =>
      setItems((prev) => (qty <= 0 ? prev.filter((i) => !(i.id === id && i.size === size && (i.color || "") === (color || ""))) : prev.map((i) => (i.id === id && i.size === size && (i.color || "") === (color || "") ? { ...i, qty } : i))));
    const clear = () => setItems([]);
    const count = items.reduce((s, i) => s + i.qty, 0);
    const total = items.reduce((s, i) => s + (i.price || 0) * i.qty, 0);
    return { items, add, remove, setQty, clear, count, total };
  }, [items]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);

export const imgSrc = (path) =>
  !path ? "" : path.startsWith("http") || path.startsWith("/assets/") ? path : `${process.env.REACT_APP_BACKEND_URL}/api/files/${path}`;
